import O81 from '../../../media/GW/O8.webp'
import O82 from '../../../media/GW/O8.webp'


const O8mages =[
O81,O82
]

export default O8mages;